import { isVector2, Vector2, type Vector2Data } from './vector-2.ts';
import { isVector3, Vector3 } from './vector-3.ts';
import { isVector4, Vector4 } from './vector-4.ts';

export const vectorReviver = (_key: string, value: any) => {
  if (value && value.type) {
    if (isVector2(value as Vector2Data)) {
      return new Vector2(value.x, value.y);
    } else if (isVector3(value)) {
      return new Vector3(value.x, value.y, value.z);
    } else if (isVector4(value)) {
      return new Vector4(value.x, value.y, value.z, value.w);
    }
  }
  return value;
};

export { Matrix } from './matrix.ts';
export {
  Vector2,
  isVector2,
  emptyVector2,
  vector2ToVec2,
  vector2EqualsFloat32,
} from './vector-2.ts';
export type { Vector2Data, Vector2Source } from './vector-2.ts';
export { Vector3, isVector3, emptyVector3 } from './vector-3.ts';
export { Vector4, isVector4, emptyVector4 } from './vector-4.ts';
export { LineDirection } from '@canvas/vector-types';
